export default __webpack_public_path__ + "static/2-561079ceadc13219f501241a2cab95d5.jpeg";